import React, { useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';
import PopUpButton from '../popup/PopUpButton';
import PopUp from '../popup/PopUp';
import CornerTypesPopupContent from '../popup/CornerTypesPopupContent';
import CornerType from '../common/CornerType';
import PropTypes from 'prop-types';

const CornerTypes = props => {
  const { cornerTypes, activeCorner, changeCornerType, cornerHulls, activeValue } = props;

  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);
  const setCorner = activeItem => {
    let wardrobes = [...wardrobesConfigs];
    let color = activeValue.split('-').pop();
    let corner = cornerHulls.filter(item => {
      return item.types.hasOwnProperty(activeItem.id) && item.safo.split('-').pop() === color;
    });

    wardrobes[activeWardrobe] = corner[0];
    setWardrobesConfigs(wardrobes);
    changeCornerType(activeItem);
  };

  let corners = [...cornerTypes];
  corners = corners.filter(item => {
    const wardrobePlusOne = wardrobesConfigs[activeWardrobe + 1]
      ? wardrobesConfigs[activeWardrobe + 1]
      : null;
    const wardrobeMinusOne = wardrobesConfigs[activeWardrobe - 1]
      ? wardrobesConfigs[activeWardrobe - 1]
      : null;
    const wardrobePlusOneDim = wardrobePlusOne ? wardrobePlusOne.dimensions.z : null;
    const wardrobeMinusOneDim = wardrobeMinusOne ? wardrobeMinusOne.dimensions.z : null;
    if (wardrobeMinusOne !== null && wardrobePlusOne !== null) {
      if (wardrobeMinusOneDim !== wardrobePlusOneDim) {
        if (wardrobeMinusOneDim === 66 && wardrobePlusOneDim === 45) {
          if (item.id === 10) {
            return true;
          }
        }
        if (wardrobeMinusOneDim === 45 && wardrobePlusOneDim === 66) {
          if (item.id === 9) {
            return true;
          }
        }
      } else {
        return true;
      }
    }
    if (wardrobeMinusOne !== null) {
      if (wardrobeMinusOneDim === 45) {
        if (item.id === 9) {
          return true;
        } else {
          return false;
        }
      }
      if (wardrobeMinusOneDim === 66) {
        if (!wardrobePlusOne) {
          return true;
        } else {
          if (item.id === 10) {
            return true;
          } else {
            return false;
          }
        }
      }
    }
    if (wardrobePlusOne !== null) {
      if (wardrobePlusOneDim === 45) {
        if (item.id === 10) {
          return true;
        } else {
          return false;
        }
      }
      if (wardrobePlusOneDim === 66) {
        if (!wardrobeMinusOne) {
          return true;
        } else {
          if (item.id === 9) {
            return true;
          } else {
            return false;
          }
        }
      }
    }
    if (activeWardrobe === 0 && wardrobesConfigs.length === 1) {
      return true;
    }
    return false;
  });

  // ? this dependency fixes issue with infinite loop - CU
  const newCornerId = corners?.[0]?.id;
  useEffect(() => {
    if (corners?.length === 1 && activeValue !== null) {
      setCorner(corners[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeValue, newCornerId]);

  return (
    <div className="corner-types">
      <div className="flex corner-types__top">
        <p className="corner-types__title">Typ narożnika:</p>
        <PopUpButton icon="help-circle" popupName="info-popup" />
        <PopUp title="Typ narożnika" popupName="info-popup">
          <CornerTypesPopupContent corners={cornerTypes} />
        </PopUp>
      </div>
      {corners.map(item => (
        <React.Fragment key={`corner-${item.id}`}>
          <CornerType item={item} setCorner={setCorner} activeCorner={activeCorner} />
        </React.Fragment>
      ))}
    </div>
  );
};

CornerTypes.propTypes = {
  cornerTypes: PropTypes.array,
};

const mapStateToProps = state => {
  return {
    cornerHulls: state.products.cornerHulls,
  };
};

export default connect(mapStateToProps)(CornerTypes);
